/****
 *
 *  GPT file as a singleton
 *
 */
class GptManager {
  static createInstance() {
    return new GptManager(arguments[0])
  }

  static getGptInstance(callback) {
    if (!window.googletag) {
      const instance = GptManager.createInstance('__getInstance__')

      instance
        .initScriptTag()
        .then(() => {
          return callback(null, window.googletag)
        })
        .catch((err) => {
          throw err
        })
    } else {
      return callback(null, window.googletag)
    }
  }

  constructor() {
    if (arguments[0] !== '__getInstance__') {
      throw Error('Do not instantiate directly use getInstance')
    }
    this.gptScript = null
  }

  initScriptTag() {
    this.setGptScript()
    return this.loadScript()
      .then(() => {
        if (!window.googletag) {
          throw Error('Failed to init GPT')
        }
        return window.googletag
      })
      .catch((err) => {
        throw err
      })
  }

  setGptScript() {
    this.gptScript = '//www.googletagservices.com/tag/js/gpt.js'
  }

  loadScript() {
    return new Promise((resolve, reject) => {
      const element = document.createElement('script')
      const target = document.getElementsByTagName('script')[0]
      element.src = this.gptScript
      element.async = true
      element.type = 'text/javascript'
      element.onload = resolve
      element.onerror = reject

      target.parentNode.insertBefore(element, target)
    })
  }
}

export default GptManager
